import {
  createContext,
  PropsWithChildren,
  Reducer,
  useContext,
  useReducer,
} from 'react';
import { ACTION_TYPES, MessageActions } from './actions';
import { MessageInitialState, MessagesState } from './types';

const SnackbarContext = createContext<
  [MessagesState, React.Dispatch<MessageActions>]
>([MessageInitialState, action => action]);

const messageReducer: Reducer<MessagesState, MessageActions> = (
  prevState,
  action,
) => {
  switch (action.type) {
    case ACTION_TYPES.ADD: {
      const newState = {
        snackbars: [
          ...prevState.snackbars,
          { message: action.message, id: action.id, colorSet: action.colorSet },
        ],
      };
      return newState;
    }
    case ACTION_TYPES.REMOVE: {
      const newState = {
        snackbars: prevState.snackbars.filter(
          message => message.id !== action.id,
        ),
      };
      return newState;
    }
    default:
      return prevState;
  }
};

export const SnackbarProvider = ({ children }: PropsWithChildren<{}>) => {
  return (
    <SnackbarContext.Provider
      value={useReducer(messageReducer, MessageInitialState)}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

// Use this hook to schedule a snackbar notification
export const useSnackbarNotifications = () => useContext(SnackbarContext);

export default SnackbarProvider;
